module.exports = __webpack_public_path__ + "img/logo-helloromania.414f92dc.png";